import { render, staticRenderFns } from "./MarkupDetails.vue?vue&type=template&id=e4f108d2&scoped=true"
import script from "./MarkupDetails.vue?vue&type=script&lang=js"
export * from "./MarkupDetails.vue?vue&type=script&lang=js"
import style0 from "./MarkupDetails.vue?vue&type=style&index=0&id=e4f108d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f108d2",
  null
  
)

export default component.exports